import { normalize } from 'react-style-reset'
import { css } from '@emotion/react'

const styleSheet = css`
  ${normalize as any};
` as any

export default styleSheet
